import { createMuiTheme } from "@material-ui/core/styles";

export const getAppThemeMode = () =>
  (typeof window !== "undefined" &&
    window.localStorage &&
    window.localStorage.getItem("themeMode")) ||
  "dark";

export const buildMuiTheme = mode => {
  if (mode === "dark") {
    return createMuiTheme({
      palette: {
        type: "dark",
        primary: {
          main: "#80a3ff",
          contrastText: "#181818"
        },
        secondary: {
          main: "#7b64b8"
        },
        background: {
          default: "#181818",
          paper: "#1f1f1f"
        },
        text: {
          primary: "#f0f0f0",
          secondary: "rgba(240,240,240,0.74)"
        },
        divider: "rgba(240,240,240,0.12)"
      },
      overrides: {
        MuiPaper: {
          root: {
            backgroundColor: "#1f1f1f",
            backgroundImage: "none"
          },
          elevation1: {
            boxShadow: "none",
            border: "1px solid rgba(240,240,240,0.12)"
          }
        },
        MuiExpansionPanel: {
          root: {
            backgroundColor: "#1f1f1f",
            border: "1px solid rgba(240,240,240,0.12)",
            borderRadius: "12px !important",
            marginBottom: "8px",
            "&:before": {
              display: "none"
            },
            "&$expanded": {
              margin: "0 0 8px 0"
            }
          }
        },
        MuiExpansionPanelSummary: {
          root: {
            backgroundColor: "#1f1f1f",
            minHeight: 48
          },
          content: {
            margin: "12px 0"
          }
        },
        MuiExpansionPanelDetails: {
          root: {
            backgroundColor: "#1a1a1a",
            borderTop: "1px solid rgba(240,240,240,0.08)"
          }
        },
        MuiTabs: {
          indicator: {
            backgroundColor: "#80a3ff",
            height: 3,
            borderRadius: 3
          }
        },
        MuiTab: {
          root: {
            color: "rgba(240,240,240,0.74)",
            "&$selected": {
              color: "#f0f0f0"
            }
          }
        },
        MuiTableCell: {
          root: {
            borderBottom: "1px solid rgba(240,240,240,0.08)",
            color: "#f0f0f0"
          },
          head: {
            color: "rgba(240,240,240,0.74)",
            fontWeight: 500
          }
        },
        MuiChip: {
          root: {
            backgroundColor: "rgba(128, 163, 255, 0.12)",
            color: "#f0f0f0"
          }
        },
        MuiOutlinedInput: {
          root: {
            "& fieldset": {
              borderColor: "rgba(240,240,240,0.12)"
            },
            "&:hover fieldset": {
              borderColor: "rgba(128, 163, 255, 0.45) !important"
            }
          }
        },
        MuiSwitch: {
          switchBase: {
            color: "rgba(240,240,240,0.5)",
            "&$checked": {
              color: "#80a3ff"
            },
            "&$checked + $track": {
              backgroundColor: "rgba(128, 163, 255, 0.45)"
            }
          }
        },
        MuiFormLabel: {
          root: {
            color: "rgba(240,240,240,0.74)",
            "&$focused": {
              color: "#80a3ff"
            }
          }
        },
        MuiIconButton: {
          root: {
            color: "rgba(240,240,240,0.74)"
          }
        },
        MuiDivider: {
          root: {
            backgroundColor: "rgba(240,240,240,0.12)"
          }
        },
        MuiCssBaseline: {
          "@global": {
            ".MuiExpansionPanelSummary-expandIcon": {
              color: "rgba(240,240,240,0.74)"
            }
          }
        }
      }
    });
  }
  return createMuiTheme();
};

export const appMuiTheme = buildMuiTheme(getAppThemeMode());
